// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__PgcIE","hideUpdateProfile":"style__hideUpdateProfile__4RD53"};